import { Copy } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { SiteConfig } from '@/lib/api';
import { useSiteConfig } from '@/hooks/useSiteConfig';

type Promo = NonNullable<SiteConfig['promo_bar']>;

// Shown until the admin-managed config arrives (Content → Homepage →
// Announcement bar). Matches the seeded default so there's no flash of change.
const FALLBACK: Promo = {
  enabled: true,
  text: 'Free Delivery on Orders Above ₹999',
  code: 'ESYFREE',
  cta_label: '',
  cta_url: '',
};

export default function PromoBar() {
  const [copied, setCopied] = useState(false);
  const siteConfig = useSiteConfig();
  // Keep the fallback until an admin-configured bar actually arrives.
  const configured = siteConfig?.promo_bar;
  const promo: Promo = configured && Object.keys(configured).length ? configured : FALLBACK;

  if (promo.enabled === false) return null;

  const handleCopy = () => {
    if (!promo.code) return;
    navigator.clipboard.writeText(promo.code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="promo-bar">
      {promo.text}
      {promo.code && (
        <>
          {' '}| Use Code:
          <button onClick={handleCopy} className="code" style={{ cursor: 'pointer', border: 'none' }}>
            {copied ? 'Copied!' : promo.code}
            <Copy size={14} />
          </button>
        </>
      )}
      {promo.cta_label && (
        <Link to={promo.cta_url || '/categories'} className="promo-bar-cta">
          {promo.cta_label}
        </Link>
      )}
    </div>
  );
}
